<template>
    <ul class="custom flex-wrap d-flex list-unstyled">
        <li :class="'px-1 ' + (current_page == 1 ? 'custom_disabled' : '')">
            <a class="" href="#" @click.prevent="goTo(1)">
                <b-icon icon="chevron-bar-left" />
            </a>
        </li>


        <li :class="'px-1 ' + (current_page == 1 ? 'custom_disabled' : '')">
            <a class="" href="#" @click.prevent="goTo(current_page - 1)">
                <b-icon icon="chevron-left" />
            </a>
        </li>

        <template v-for="(page, index) in pages">
            <li v-if="page > 0 && page <= last_page" :key="index" :class="'px-1 ' + (current_page == page ? 'custom_active' : '')">
                <a class="" href="#" @click.prevent="goTo(page)">{{ page }}</a>
            </li>
        </template>

        <li :class="'px-1 ' + (current_page == last_page ? 'custom_disabled' : '')">
            <a class="px-1" href="#" @click.prevent="goTo(current_page + 1)">
                <b-icon icon="chevron-right" />
            </a>
        </li>

        <li :class="'px-1 ' + (current_page == last_page ? 'custom_disabled' : '')">
            <a class="px-1" href="#" @click.prevent="goTo(last_page)">
                <b-icon icon="chevron-bar-right" />
            </a>
        </li>
    </ul>
</template>

<script>
    export default {
        props: {
            'current_page': Number,
            'last_page': Number
        },
        data() {
            return {
                pages: [],
                isMobile: window.innerWidth < 768
            }
        },
        created() {
            this.setPages();
        },
        watch: {
            isMobile() {
                this.setPages();
            },
            current_page() {
                this.setPages();
            },
            last_page() {
                this.setPages();
            }
        },
        computed: {
        },
        mounted() {
            window.addEventListener('resize', () => {
                this.isMobile = window.innerWidth < 768;
            });
        },
        methods: {
            setPages() {
                this.pages = [];
                if(this.isMobile) {
                    for (var i = this.current_page; i <= this.current_page; i++) {
                        this.pages.push(i);
                    }
                } else {
                    for (var j = this.current_page - 3; j <= this.current_page + 3; j++) {
                        this.pages.push(j);
                    }
                }
            },
            goTo(page) {
                if(page != this.current_page) {
                    this.$emit('change_page', page);
                }
            }
        }
    }
</script>
<style scoped>
.custom {
    border: none;
    background-color: transparent;
    margin: 0;
}

.custom a {
    text-decoration: none;
    color: inherit;
    display: inline-block;
    padding: 2px 8px;
    transition: background-color 0.2s;
}

.custom li:not(.custom_disabled):hover a {
    background-color: black;
    color: white;
    cursor: pointer;
}

.custom_disabled a {
    pointer-events: none;
    color: #ccc;
}

.custom_disabled {
    cursor: default;
}

.custom_active a {
    background-color: black;
    color: white;
    cursor: default;
}

.custom_active:hover a {
    background-color: black;
    color: white;
}
</style>
